import { TableRow, TableCell, Box } from "@mui/material";

const SkeletonRow = ({ colSpan }) => (
  <TableRow>
    {Array.from({ length: colSpan }).map((_, index) => (
      <TableCell key={index}>
        <Box
          sx={{
            height: 20,
            bgcolor: "grey.200",
            borderRadius: 1,
            animation: "pulse 1.5s ease-in-out infinite",
            "@keyframes pulse": {
              "0%, 100%": { opacity: 1 },
              "50%": { opacity: 0.5 },
            },
          }}
        />
      </TableCell>
    ))}
  </TableRow>
);

export default function TableSkeleton({ loading, colSpan, rows = 5 }) {
  if (!loading) return null;

  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <SkeletonRow key={index} colSpan={colSpan} />
      ))}
    </>
  );
}

